<div class="dropdown">
    <button type="button" id="organization-search-filter-dropdown" class="btn btn-ms-secondary dropdown-toggle"
        data-bs-auto-close="outside" data-bs-toggle="dropdown" aria-expanded="false">
        <fa-duotone-icon icon="filter" secondaryOpacity="0.6" class="fs-6 d-none d-sm-inline" />
        Filter
        @if (filterCount > 0) {
        <span
            class="position-absolute top-0 start-0 translate-middle badge border rounded-circle filter-count">{{filterCount}}</span>
        }
    </button>

    <!--begin::Menu 1-->
    <div ms-parent-focus [alwaysFocusOnRemoval]="true" class="dropdown-menu" (keyup.control.enter)="onApply()">

        <!--begin::Header-->
        <div class="fs-5 fw-bold px-3 py-2">Filter Options</div>
        <!--end::Header-->

        <!--begin::Separator-->
        <div class="separator border-gray-200"></div>
        <!--end::Separator-->

        <!--begin::Content-->

        <!-- First Name Input with Add Button -->
        <div class="mb-2 px-3 py-2 mw-100">
            <label class="form-label fw-semibold">Organization Name:</label>
            <div class="input-group">
                <input type="text" class="form-control form-control-solid" placeholder="Enter Organization Name"
                    [(ngModel)]="organizationNameInput" (keyup.enter)="addName()" />
                <button class="btn btn-primary px-3" type="button" (click)="addName()">
                    <fa-duotone-icon icon="plus" secondaryOpacity="0.9" />
                </button>
            </div>
            <div class="d-flex flex-wrap w-100">
                <!-- Display added organization names -->
                @if (userSessionService.organizationsFilter.names && userSessionService.organizationsFilter.names.length
                > 0) {
                <div class="mt-2">
                    @for (name of userSessionService.organizationsFilter.names; track $index) {
                    <button class="tag-filter btn btn-primary" type="button" (click)="removeName($index)">{{name}}
                        <fa-duotone-icon icon="minus" secondaryOpacity="0.9" />
                    </button>
                    }
                </div>
                }
            </div>
        </div>

        <!--begin::Multi-select Input group-->
        <div class="mb-2 px-3 py-2">
            <label class="form-label fw-semibold">Billing Status:</label>
            <ms-multi-select placeholder="Select Billing Status" [options]="selectBillingStatusOptions"
                [(selectedOptions)]="selectedBillingStatusOptions" (selectionChange)="onBillingStatusChange($event)" />
        </div>
        <!--end::Multi-select Input group-->

        <!--begin::Multi-select Input group-->
        <div class="mb-2 px-3 py-2">
            <label class="form-label fw-semibold">Pricing Tier:</label>
            <ms-multi-select placeholder="Select Pricing Tier" [options]="selectPricingTierOptions"
                [(selectedOptions)]="selectedPricingTierOptions" (selectionChange)="onPricingTierChange($event)" />
        </div>
        <!--end::Multi-select Input group-->

        <!--begin::Multi-select Input group-->
        <div class="mb-2 px-3 py-2">
            <label class="form-label fw-semibold">Status:</label>
            <ms-multi-select placeholder="Select Status" [options]="selectStatusOptions"
                [(selectedOptions)]="selectedOrganizationStatusOptions" (selectionChange)="onStatusChange($event)" />
        </div>
        <!--end::Multi-select Input group-->

        <!--begin::Actions-->
        <div class="d-flex justify-content-end px-3 py-2">
            <button type="reset" class="btn btn-ms-secondary reset-filter-button me-2 px-6"
                (click)="onReset()">Reset</button>
            <button type="submit" class="btn btn-primary px-6" (click)="onApply()">Apply</button>
        </div>
        <!--end::Actions-->

        <!--end::Content-->
    </div>
    <!--end::Menu 1-->
</div>